"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonValidateAndGotoNextSection = void 0;
/**
 * Get the configuration for a button that will call the `validateButtonAction`
 * provided in the options when clicked.
 *
 * @param translatableLabel The text to use for this button. It should be a
 * translatable string key, automatically, its custom version in the
 * customSurvey namespace will be added to the call
 * @param options
 * @returns {ButtonWidgetConfig} The configuration object for the button widget.
 */
const getButtonValidateAndGotoNextSection = (translatableLabel, 
// FIXME: Type this when there is a few more widgets implemented
options) => {
    return {
        type: 'button',
        // FIXME Is the path important for a button? Should it be configurable, like the text?
        path: 'buttonValidateGotoNextSection',
        color: 'green',
        label: (t) => t([`customSurvey:${translatableLabel}`, translatableLabel]),
        hideWhenRefreshing: true,
        icon: options.iconMapper['check-circle'],
        align: 'center',
        action: options.buttonActions.validateButtonAction
    };
};
exports.getButtonValidateAndGotoNextSection = getButtonValidateAndGotoNextSection;
//# sourceMappingURL=buttonValidateAndGotoNextSection.js.map